import { effectiveSpan } from "./columnSpan";
import { useForcedBreakpoint } from "./forcedBreakpoint";
import { GridColumnProps } from "./GridColumn.types";

/**
 * Applies a Bootstrap 12-column span per breakpoint. The defaults live in
 * `effectiveSpan`, which the width controls read too.
 *
 * Under a forced breakpoint - the designer's tablet and mobile previews - it applies that
 * breakpoint's span alone, as a plain `col-*`, so the layout does not depend on a media
 * query the preview's box cannot answer.
 */
export function GridColumn({ span, children, className = "" }: GridColumnProps) {
  const forced = useForcedBreakpoint();
  const spans = forced
    ? [`col-${effectiveSpan(span, forced)}`]
    : [
        `col-${effectiveSpan(span, "mobile")}`,
        `col-md-${effectiveSpan(span, "tablet")}`,
        `col-lg-${effectiveSpan(span, "desktop")}`,
      ];
  const classes = [
    ...spans,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return <div className={classes}>{children}</div>;
}
